import { createSelector } from 'reselect';

const chatGameGetter = (state: any) => state.chat.messages;

export const getGameChat = createSelector(chatGameGetter, messages =>
  messages.valueSeq().toArray()
);
